import React, { forwardRef } from 'react';

import classNames from 'classnames';

import { Popup, PopupProps, PopupTheme } from './Popup/Popup';

import './Tooltip.scss';

type Size = 'auto' | 'small' | 'medium' | 'large' | 'extra-large';

type Props = PopupProps & {
    readonly size?: Size;
};

export const Tooltip = forwardRef<HTMLDivElement, Props>(
    ({ size = 'auto', theme = PopupTheme.DARK, className, ...props }, ref) => {
        return (
            <Popup
                {...props}
                ref={ref}
                theme={PopupTheme.DARK}
                className={classNames('tooltip-popup', `tooltip-popup--${size}`, className)}
            />
        );
    }
);
